import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.EduToggleNavbar = class EduToggleNavbar extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-toggle-navbar';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.buttons = $(this.$element.find('.filter-button-wrap'));
        this.buttonsInside = $(this.$element.find('.filter-button'));
        this.inputs = $(this.$element.find('.filter-button-wrap input'));
        this.inputsCheckbox = $(this.$element.find('.filter-button-wrap input[type=checkbox]'));
        this.filterButton = (this.$element.find('.show-hide-filters'));
        this.activeButton = '';
        this.activeDropdown = '';
        this.clearAllButton = $(this.$element.find('.clear-all-button'));
        this.floatingFiltersButton = $(this.$element.find('.floating-filter-holder'));
    }

    handleClick(e) {
        let windowSize = 0;
        this.activeButton = $(e.currentTarget);
        
        if ((!this.activeButton.hasClass('disabled'))) {
            windowSize = $(window).innerWidth();
            
            let boxSize = this.activeButton.find('ul').outerWidth() + this.activeButton.offset().left
            
            if (this.activeButton.hasClass('active')) {
                this.activeButton.find('ul').css({ left: 0 })
                this.activeButton.find("ul").hide();
                this.activeButton.removeClass('active');
            } else {
                this.buttons.removeClass('active');
                this.buttons.find('ul').hide();
                if (parseInt(boxSize) > windowSize) {
                    this.activeButton.find('ul').css({ left: -((boxSize - windowSize)+15) })
                }
                this.activeButton.find("ul").show();
                
                this.activeButton.addClass('active');
            }           
        }
        e.stopPropagation();
    }

    handleInputClick() {
        
        let activeInputLength = this.activeButton.find('input:checked').length;
        let originalInputName = this.activeButton.find('.filter-button').data("name");
        
        if (this.activeButton.hasClass('by-date')) {
            if (activeInputLength > 0) {
                this.activeButton.find('.filter-button').text(this.activeButton.find('input:checked').parent().text())
            }
        } else {
            if (activeInputLength >= 1) {
                this.activeButton.find('.filter-button').text(`${originalInputName} (${activeInputLength.toString()})`);
                this.activeButton.addClass('populated');
            } else if (activeInputLength < 1) {
                this.activeButton.removeClass('populated');
                this.activeButton.find('.filter-button').text(originalInputName);
                
            }
        }
        if (this.inputsCheckbox.filter(':checked').length > 0) {
            this.clearAllButton.addClass('active')
        } else {
            if (this.$element.find('.keyword-filter input:visible').val().length < 1) {
                this.clearAllButton.removeClass('active')
            }
            
        }
        

    }

    handleOutsideClick() {
        if (this.activeButton.length > 0) {
            this.activeButton.find('ul').css({ left: 0 });
            this.activeButton.find("ul").hide()
            this.activeButton.removeClass('active');
        }
    }

    handleClearAllClick() {
        
        if (this.inputsCheckbox.length >= 1) {
            this.inputsCheckbox.prop("checked", false);
            this.buttons.map((i, button) => {
                if (!$(button).hasClass('by-date')) {
                    let originalInputName = $(button).find('.filter-button').data("name");
                    $(button).find('.filter-button').text(originalInputName);
                    $(button).removeClass('active');
                    $(button).removeClass('populated');
                }
            })
            this.clearAllButton.removeClass('active')
        }
       
    }

    showHideFIlters() {
        if (!this.filterButton.hasClass('open')) {
            this.$element.css({
                top: 70
            })
            this.filterButton.addClass('open')
        } else {
            this.$element.css({
                top: -(this.$element.height() - (70 + 40))
            })
            this.filterButton.removeClass('open')
        }
        
    }

    setEventListeners() {
        this.buttons.on('click', this.handleClick.bind(this));
        this.inputs.on('click', this.handleInputClick.bind(this));
        this.buttons.find('li').keypress(function(e){
            if ((e.keyCode ? e.keyCode : e.which) == 13) {
                $(this).find('input').trigger('click');
            }
        })
        this.buttons.keypress(function (e) {
            if ((e.keyCode ? e.keyCode : e.which) == 13) {
                $(this).trigger('click');
            }
        })
        this.$element.find('.site-search__button').focus(function () {
            $(this).blur();
        });

        this.clearAllButton.on('click', this.handleClearAllClick.bind(this));
        $(document).on('click', this.handleOutsideClick.bind(this));
        this.filterButton.on('click', this.showHideFIlters.bind(this));
        
        this.floatingFiltersButton.find('span').on('click', this.goToAnchor.bind(this));
        
        $(window).on('resize', () => {
            this.buttons.removeClass('active');
            this.buttons.find('ul').hide();
            if ($(window).width() > 768) {
                this.floatingFiltersButton.hide();
            }
        })
    }

    init() {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('recommended')) {
            if (localStorage.getItem('filtersMap')) {
                let test = new Map(JSON.parse(localStorage.getItem('filtersMap')));
                test.forEach((value, key) => {
                    this.buttons.map((i, button) => {
                        if (value.length > 0 && $(button).attr('id') == key) {
                            value.split(',').map((v) => {
                                $(button).find(`input[value='${v}']`).attr('checked', true);
                            })
                        }
                    })
                })
            }
        }

        this.buttons.map((i, button) => {
            let activeInputLength = $(button).find('input:checked').length;
            let originalInputName = $(button).find('.filter-button').data("name");

            if (!$(button).hasClass('by-date')) {
                if (activeInputLength >= 1) {
                    $(button).find('.filter-button').text(`${originalInputName} (${activeInputLength.toString()})`);
                    $(button).addClass('populated');
                } else if (activeInputLength < 1) {
                    $(button).removeClass('populated');
                    $(button).find('.filter-button').text(originalInputName);
                }
            }
        })

        $(window).on('scroll.showFilterButton', () => {
            if ($(window).width() <= 768) {
                if ($(window).scrollTop() > this.$element.offset().top) {
                    this.floatingFiltersButton.fadeIn();
                } else {
                    this.floatingFiltersButton.fadeOut();
                }
            }
        })
        
    }

    goToAnchor() {
        let anchor = $(this.$element.find('.bootroom-filters-anchor'));
        $('html, body').animate({ scrollTop: anchor.offset().top - 100 }, 500);
    }

    render() {
        this.setVars();
        this.init();
        this.setEventListeners();
    }

}

Snappy.Component.BootroomFilters = class BootroomFilters extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-filters';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.init();
        this.setEventListeners();
    }

    setEventListeners() {
        this.buttons.on('click', this.handleClick.bind(this));
        this.inputs.on('click', this.handleInputClick.bind(this));
        this.clearAllButton.on('click', this.handleClearAllClick.bind(this));
        window.addEventListener("DOMContentLoaded", this.handleFeaturedCall(this));

        $(window).on('resize', () => {
            this.handleKeywordInput();
        })

        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
    }

    init() {
        let filtersMap = new Map();
        this.buttons.map((i, button) => {
            filtersMap.set(button.id, "");
        })
        this.filtersInfo = filtersMap;
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('recommended')) {
            if (localStorage.getItem('filtersMap')) {
                let localFiltersMap = new Map(JSON.parse(localStorage.getItem('filtersMap')));
                localFiltersMap.forEach((value, key) => {
                    if (value.length > 0) {
                        if (this.urlFilters.length > 0) {
                            this.urlFilters += '&'
                        }
                        this.urlFilters += `${key}=${value}`
                    }

                    this.filtersInfo.set(key, value)
                })
            }
        }

        this.resultsContainer.append(this.createPage(this.pageNumber))
        this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`).append(`<div class='loading'></div>`)

        this.handleKeywordInput();


    }

    setVars() {
        this.buttons = $(this.$element.find('.filter-button-wrap'));
        this.inputs = $(this.$element.find('.filter-button-wrap input'));
        this.keywordInput = $(this.$element.find('.keyword-filter input'));
        this.resultsContainer = $(this.$element.find('.bootroom-filters__results'));

        this.clearAllButton = $(this.$element.find('.clear-all-button'));

        this.keyword = '';
        this.activeButton = '';
        this.filtersInfo = {};
        this.urlFilters = '';
        this.jsonUrl = $(this.$element).data('jsonUrl');

        this.filteredData = [];
        this.featuredData = [];
        this.excludedValuesById = '';

        this.pageNumber = 1;
        this.totalPages = 1;
        this.cardsPerPage = parseInt($(this.$element).data('cardsPerPage'));


        this.loading = false;
        this.loadingMore = false;
        this.stillLoading = false;

        this.totalLoadedResults = 0;

        this.exceededCards = 0;

        this.rest = 0
    }

    handleClick(e) {
        this.activeButton = $(e.currentTarget);
    }

    handleInputClick(e) {
        $(window).off('.loadMore')
        this.resultsContainer.empty()
        this.goToAnchor();
        this.urlFilters = '';
        this.loadingMore = false;
        this.pageNumber = 1;
        let test = [];
        this.activeButton.find('input:checked').map((i, input) => {
            test.push($(input).attr('value'));
        })

        this.filtersInfo.set(this.activeButton.attr('id'), test.toString())

        this.filtersInfo.forEach((value, key) => {

            if (value.length > 0) {
                if (this.urlFilters.length > 0) {
                    this.urlFilters += '&'
                }
                this.urlFilters += `${key}=${value}`
            }

        })

        if (this.loading == true) {
            this.stillLoading = true;
        } else {
            this.stillLoading = false;
        }
        //localStorage.setItem('filtersMap', JSON.stringify(Array.from(this.filtersInfo)));
        this.handleFeaturedCall();
    }

    handleAfterCall() {
        this.resultsContainer.empty()
        let nextPage = [];
        let page = [];
        let resultsLength = (this.filteredData.length) + this.exceededCards
        //console.log("test", resultsLength)
        //console.log('rest', this.rest)
        this.totalLoadedResults = resultsLength;
        this.rest = resultsLength % 3;

        this.resultsContainer.append(this.createPage(this.pageNumber))
        page = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`)

        if (this.rest > 0) {
            this.resultsContainer.append(this.createPage(this.pageNumber + 1))
            nextPage = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber + 1}]`)
        }
        if (this.filteredData.length > 0) {
            this.filteredData.forEach((data, i) => {
                if (i < 1) {
                    if (this.featuredData.length > 0) {
                        this.featuredData.forEach((dataFeatured, j) => {
                            if (j <= 1) {
                                if (this.featuredData.length > 1) {
                                    page.find('.content').append(this.createCardMedium(dataFeatured))
                                } else {
                                    page.find('.content').append(this.createCardLarge(dataFeatured))
                                }
                            }
                        })
                    }
                }
                if (i === 6) {
                    if (this.featuredData.length > 2) {
                        this.featuredData.forEach((dataFeatured, j) => {
                            if (j === 2) {
                                page.find('.content').append(this.createCardLarge(dataFeatured))
                            }
                        })
                    }
                }

                if (this.rest > 0) {

                    if (this.totalPages != this.pageNumber) {
                        if (i < (this.filteredData.length) - this.rest) {
                            page.find('.content').append(this.createCardSmall(data));
                        } else {
                            nextPage.find('.content').append(this.createCardSmall(data));
                        }
                    } else {
                        page.find('.content').append(this.createCardSmall(data));
                    }
                } else {
                    page.find('.content').append(this.createCardSmall(data));
                }

            })
        } else {
            if (this.featuredData.length > 0) {
                this.featuredData.forEach((dataFeatured, j) => {
                    if (j <= 1) {
                        if (this.featuredData.length > 1) {
                            page.find('.content').append(this.createCardMedium(dataFeatured))
                        } else {
                            page.find('.content').append(this.createCardLarge(dataFeatured))
                        }
                    }
                    if (j === 2) {
                        page.find('.content').append(this.createCardLarge(dataFeatured))
                    }
                })
            }
        }

        if (this.featuredData.length > 2) {
            this.waitForElement($('.bootroom-card-f.card__m'), this.equalizeFeatureHeight)
            this.equalizeLargeFeaturedHeight();
        }
        if (this.featuredData.length == 1) {
            this.equalizeLargeFeaturedHeight();
        }
        if (this.featuredData.length == 2) {
            this.waitForElement($('.bootroom-card-f.card__m'), this.equalizeFeatureHeight)
        }
        
        
        
        $(page).find('.content').fadeIn(1000, () => {
            if (this.totalPages != this.pageNumber) {
                $(window).on('scroll.loadMore', this.handleScroll.bind(this))
            }
            this.$element.find('.loading').fadeOut('slow', () => {
                this.$element.find('.loading').remove();
            });
            
        })
       
    }

    handleFeaturedCall() {
        this.excludedValuesById = '';
        this.loading = true;
        if (this.resultsContainer.is(':empty')) {
            this.resultsContainer.append(this.createPage(this.pageNumber))
            let page = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`);
            page.append(`<div class='loading'></div>`)
        }
        $.ajax({
            context: this,
            type: "GET",
            dataType: "json",
            url: `${this.jsonUrl}?${this.urlFilters ? `${this.urlFilters}&` : ``}isFeatured=true&resultPerPage=3&page=1${this.keyword}`,
            data: {
                //page: this.i,
                //url: window.location.pathname.toString()
            },
            //beforeSend: function (xhr) {
            //    if (this.stillLoading == true) {
            //        console.log('abort - featured,', xhr)
            //        xhr.abort();
            //        this.stillLoading = false;
            //        return;
            //    }
            //},
            success: function (result, textStatus, request) {
                this.featuredData = result.eduResoucesArticles;

                switch (this.featuredData.length) {
                    case 1:
                        this.exceededCards = 2;
                        break;
                    case 2:
                        this.exceededCards = 3;
                        break;
                    case 3:
                        this.exceededCards = 5;
                        break;
                    case 0:
                        this.exceededCards = 0;
                        break;
                    default:
                        this.exceededCards = 0;
                }
                if (this.featuredData.length > 0) {
                    this.excludedValuesById = "&removeByID="
                    this.featuredData.forEach((dataFeatured, i) => {
                        if (i > 0 && i <= this.featuredData.length-1) {
                            this.excludedValuesById += ','
                        }
                        this.excludedValuesById += dataFeatured.id;
                    })
                }
                this.handleCall();
            },
            error: function () {

            }
        });
    }

    handleCall() {
        $(window).off('.loadMore')
        this.totalPages = 1;
        $.ajax({
            context: this,
            type: "GET",
            dataType: "json",
            url: `${this.jsonUrl}?${this.urlFilters.length ? `${this.urlFilters}&` : ``}page=${this.pageNumber}&resultPerPage=${this.cardsPerPage}${this.excludedValuesById}${this.keyword}`,
            data: {
                //page: this.i,
                //url: window.location.pathname.toString()
            },
            //beforeSend: function (xhr) {
            //    if (this.stillLoading == true) {
            //        console.log('abort')
            //        xhr.abort();
            //        this.stillLoading = false;
            //        this.loading = false;
            //    }
            //},
            success: function (result, textStatus, request) {
                this.filteredData = result.eduResoucesArticles;
                if (result.totalPages > 1) {
                    this.totalPages = result.totalPages;
                }
                if (this.loadingMore == true) {
                    this.loading = false;
                    if (this.filteredData.length > 0) {
                        this.handleLoadingMore(); //load more results
                    } else {
                        this.showingHiddenResults(); //showing last results that were be hidden to not mess up the UI
                    }
                } else {
                    if (this.filteredData.length > 0 || this.featuredData.length > 0) {
                        this.handleAfterCall();
                    } else {
                        this.resultsContainer.html('<div class="no-results">No results</div>');
                    }
                }
                this.loading = false;
            },
            error: function () {

            }
        });
    }

    handleLoadingMore() {
        let page = [];
        
        let nextPage= [];
        this.totalLoadedResults += this.filteredData.length;
        this.rest = this.totalLoadedResults % 3;
        
        if (this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`).length < 1) {
            this.resultsContainer.append(this.createPage(this.pageNumber))
        }
        page = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`);

        if (this.rest > 0) {
            if (this.totalPages != this.pageNumber) {
                if (this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber + 1}]`).length < 1) {
                    this.resultsContainer.append(this.createPage(this.pageNumber + 1));
                }
            }
            
            nextPage = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber + 1}]`)
        }

        if (this.rest >= 1) {
            if (this.totalPages != this.pageNumber) {
                this.filteredData.forEach((data, i) => {
                    if (i < (this.filteredData.length) - this.rest) {
                        page.find('.content').append(this.createCardSmall(data));
                    } else {
                        nextPage.find('.content').append(this.createCardSmall(data));
                    }
                });
            } else {
                this.filteredData.forEach((data, i) => {
                    page.find('.content').append(this.createCardSmall(data));
                });
            }
        } else {
            this.filteredData.forEach((data, i) => {
                page.find('.content').append(this.createCardSmall(data));
            });
        }
        
        
        $(page).find('.content').fadeIn(1000, () => {
            if (this.totalPages != this.pageNumber) {
                $(window).on('scroll.loadMore', this.handleScroll.bind(this));
            }
            this.$element.find('.loading').fadeOut('slow', () => {
                this.$element.find('.loading').remove();
            });
        })
    }

    createPage(pageNumber) {
        return `<div class="results-page"
                 style="position: relative; min-height:70px"
                 data-page-number=${pageNumber}>
                   <div class="content" style="display:none"></div>
                 </div>`
    }

    handleScroll() {
        let element = this.$element;
        let page = []
        
        if ((window.innerHeight + window.scrollY) >= parseInt(element.offset().top) + parseInt(element.height()) && this.loading == false) {

            this.loadingMore = true;
            this.pageNumber = this.pageNumber + 1;
            this.loading = true;
            
            if (this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`).length >= 1) {
                page = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`);
                page.append(`<div class='loading'></div>`)
            }
            else {
                this.resultsContainer.append(this.createPage(this.pageNumber));
                page = this.resultsContainer.find(`.results-page[data-page-number=${this.pageNumber}]`);
                page.append(`<div class='loading'></div>`)
            }
            this.handleCall();
        }
    }

    showingHiddenResults() {
        if (this.$element.find(`.results-page[data-page-number=${this.pageNumber}]`).length > 0) {
            this.$element.find(`.results-page[data-page-number=${this.pageNumber}] .content`).fadeIn('slow');
            this.$element.find('.loading').fadeOut('slow', () => {
                this.$element.find('.loading').remove();
            });
            this.loadFinished = true;
        }
    }

    goToAnchor() {
        let anchor = $(this.$element.find('.bootroom-filters-anchor'));
        if ($(window).scrollTop() > this.resultsContainer.offset().top + 20) {
            $('html, body').animate({ scrollTop: anchor.offset().top - 100 }, 500);
        }
    }

    handleKeywordInput() {
        let activeKeyword = $(this.$element.find('.keyword-filter input:visible'));

            activeKeyword.keyup((e) => {
                if (activeKeyword.val().length > 0) {
                    this.clearAllButton.addClass('active');
                } else {
                    if (this.url == '') {
                        this.clearAllButton.removeClass('active');
                    }
                }

                if (e.which == 13) {
                    this.keywordInput.val(activeKeyword.val())
                    if (activeKeyword.val().length > 0) {
                    this.keyword = `&keyword=${activeKeyword.val()}`
                    } else {
                        this.keyword = '';
                    }
                    this.resultsContainer.empty()
                    this.loadingMore = false;
                    this.handleFeaturedCall();
                    
                }
            })
            activeKeyword.parent().find('button').click(() => {
                this.keywordInput.val(activeKeyword.val())
                if (activeKeyword.length > 0) {
                    this.keyword = `&keyword=${activeKeyword.val()}`
                } else {
                    this.keyword = '';
                }
                //e.stopPropagation();
                this.resultsContainer.empty()
                this.handleFeaturedCall();
            })
        
    }

    handleClearAllClick() {
        $(window).off('.loadMore')
        this.resultsContainer.empty()
        this.urlFilters = '';
        this.keyword = '';
        this.keywordInput.val('');
        this.buttons.map((i, button) => {
            if (!$(button).hasClass('by-date')) {
                this.filtersInfo.set($(button).attr('id'), "")
            }
        })
        

        if (this.loading == true) {
            this.stillLoading = true;
        } else {
            this.stillLoading = false;
        }

        this.handleFeaturedCall();
        this.goToAnchor();
    }

    equalizeFeatureHeight() {
        let maxHeight = 0;
        let elements = $('.bootroom-card-f.card__m');

        elements.each((i, element) => {
            if ($(element).height() > maxHeight)
                maxHeight = $(element).height();
        });

        elements.find('.bootroom-card-f__image').height(maxHeight);
    }

    equalizeLargeFeaturedHeight() {
        let element = $('.bootroom-card-f.card__l');
        let nexElement = element.next('.bootroom-card')
        
        
        if (nexElement.length > 0) {
            this.waitForElement(nexElement, () => {
            if (nexElement.height() > element.height()) {
                element.find('.bootroom-card-f__image').height(nexElement.height())
                }
            })
        }
    }

     waitForElement(selector, callback) {
         if (selector.is(":visible")) {
            callback();
        } else {
            setTimeout(() => {
                this.waitForElement(selector, callback);
            }, 100);
        }
    };

    createCardSmall(data) {
        let dataContent = `
            <div class="bootroom-card card-responsive col-xs-12 col-sm-4 col-md-4">
                <a href="${data.CTA ? `${data.CTA}` : ``}">
                    <div class="bootroom-card__image lazyload"
                        ${data.picture ?
                            `data-bg="${data.picture}"` :
                            ``
                        }
                        >
                        ${data.isVideo ?
                            `<div class="play-button">
                                <span style="border-right-color: #E1261C"></span>
                            </div>` :
                            ``
                        }
                    </div>
                    <div class="card-content">
                        ${data.title?
                            `<h4>
                                ${data.title}
                            </h4>` : ``
                            }
                        ${data.interviewee || data.interviewTitle ?
                            `<h4>
                                ${data.interviewee ? `<span>${data.interviewee}</span>` : ``}
                                ${data.interviewTitle ? `${data.interviewTitle}` : ``}
                            </h4>` : ``
                        }
                        ${data.text ?
                            `<p>${data.text}</p>` : ``
                        }
                        ${data.duration ?
                            `<div class="duration">${data.duration} •</div>` : ``
                        }
                        ${data.datetime ?
                            `<div class="date">${data.datetime}</div>` : ``
                        }
                        ${(data.disciplines && !data.disciplines.empty) || (data.ageGroups && !data.ageGroups.empty) || (data.tags && !data.tags.empty) ?
                            `<div class="tags">
                                ${data.disciplines ? data.disciplines.map((discipline) => { return `<span>${discipline}</span>` }).join('') : ``} 
                                ${data.ageGroups ? data.ageGroups.map((ageGroup) => { return `<span>${ageGroup}</span>` }).join('') : ``} 
                                ${data.tags ? data.tags.map((tag) => { return `<span>${tag}</span>` }).join('') : ``}
                            </div>` : ``
                        }
                    </div>
                </a>
            </div>
        `
        return dataContent
    }

    createCardMedium(data) {
        let dataContent = `
            <div class="bootroom-card-f card__m col-xs-12 col-sm-6 col-md-6">
                <a href="${data.CTA ? `${data.CTA}` : ``}">
                    <div class="main-tag">Featured</div>
                    <div class="bootroom-card-f__image lazyload"
                        ${data.picture ?
                            `data-bg="${data.picture}"` :
                            ``
                        }
                    >
                        <div class="card-content">
                            <div class="content-size-control">
                                ${data.isVideo ?
                                    `<div class="play-button">
                                        <span style="border-right-color: #E1261C"></span>
                                    </div>` :
                                    ``
                                }
                                ${data.title ?
                                    `<h4>
                                        ${ data.title}
                                    </h4>` : ``
                                }
                                ${data.interviewee ?
                                    `<h4>
                                        <span>${data.interviewee}</span>
                                        ${data.interviewTitle ? `${data.interviewTitle}` : ``}
                                    </h4>` : ``
                                }
                                ${data.text ?
                                    `<p>${data.text}</p>` : ``
                                }
                                ${data.duration ?
                                     `<div class="duration">${data.duration} •</div>` : ``
                                }
                                ${data.datetime ?
                                    `<div class="date">${data.datetime}</div>` : ``
                                }
                                ${(data.disciplines && !data.disciplines.empty) || (data.ageGroups && !data.ageGroups.empty) || (data.tags && !data.tags.empty) ?
                                    `<div class="tags">
                                        ${data.disciplines ? data.disciplines.map((discipline) => { return `<span>${discipline}</span>` }).join('') : ``} 
                                        ${data.ageGroups ? data.ageGroups.map((ageGroup) => { return `<span>${ageGroup}</span>` }).join('') : ``} 
                                        ${data.tags ? data.tags.map((tag) => { return `<span>${tag}</span>` }).join('') : ``}
                                    </div>` : ``
                                }
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        `
        return dataContent
    }

    createCardLarge(data) {
        let dataContent = `
            <div class="bootroom-card-f card__l col-xs-12 col-sm-8 col-md-8">
                <a href="${data.CTA ? `${data.CTA}` : ``}">
                    <div class="main-tag">Featured</div>
                    <div class="bootroom-card-f__image lazyload"
                        ${data.picture ?
                            `data-bg="${data.picture}"` :
                            ``
                        }
                    >

                        <div class="card-content">
                            <div class="content-size-control">
                                ${data.isVideo ?
                                    `<div class="play-button">
                                        <span style="border-right-color: #E1261C"></span>
                                    </div>` :
                                    ``
                                }
                                ${data.title ?
                                     `<h4>
                                        ${data.title}
                                    </h4>` : ``
                                 }
                                ${data.interviewee ?
                                    `<h4>
                                        <span>${data.interviewee}</span>
                                        ${data.interviewTitle ? `${data.interviewTitle}` : ``}
                                    </h4>` : ``
                                }
                                ${data.text ?
                                    `<p>${data.text}</p>` : ``
                                }
                                ${data.duration ?
                                     `<div class="duration">${data.duration} •</div>` : ``
                                }
                                ${data.datetime ?
                                    `<div class="date">${data.datetime}</div>` : ``
                                }
                                ${(data.disciplines && !data.disciplines.empty) || (data.ageGroups && !data.ageGroups.empty) || (data.tags && !data.tags.empty) ?
                                    `<div class="tags">
                                        ${data.disciplines ? data.disciplines.map((discipline) => { return `<span>${discipline}</span>` }).join('') : ``} 
                                        ${data.ageGroups ? data.ageGroups.map((ageGroup) => { return `<span>${ageGroup}</span>` }).join('') : ``} 
                                        ${data.tags ? data.tags.map((tag) => { return `<span>${tag}</span>` }).join('') : ``}
                                    </div>` : ``
                                }
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        `
        return dataContent
    }
  
}



// WEBPACK FOOTER //
// ./components/edu-search-filters/scripts/_edu-filters.js